<template>
  <BaseDialog
    centered
    contentClass="editEvalGrid"
    ref="dialog"
    :persistent="false"
    @closeModal="closeDialog"
    :on-close="closeDialog"
    showHeader
  >
    <template slot="title"> {{ $t('evaluation-grid.management.edit-grid-title') }}</template>
    <template slot="content">
      <slot name="content"> <EvalGridManagement ref="evalGridManagement" /> </slot>
    </template>
  </BaseDialog>
</template>

<script>
import BaseDialog from '@/components/base/BaseDialog';
import EvalGridManagement from '@/components/page-pdf-analysis/EvalGridManagement';

export default {
  name: 'EditEvalGridDialog',
  components: {
    BaseDialog,
    EvalGridManagement,
  },
  props: {},
  methods: {
    openDialog() {
      this.$refs.dialog.openModal();
    },
    closeDialog() {
      this.$refs.dialog.isModalOpen = false;
      this.$refs.evalGridManagement.closeAddFieldForm();
    },
  },
};
</script>

<style lang="scss">
.base-dialog__editEvalGrid {
  height: auto;
  max-height: 85% !important;
  width: 35%;
  position: relative;
  border-radius: $border-radius-root;
  top: auto;

  .base-dialog__content {
    padding: 32px;
    font-size: 18px;
    min-height: max-content;
    background: $color-white !important;

    &::-webkit-scrollbar-track {
      background-color: $color-neutral-pale;
    }

    &::-webkit-scrollbar {
      height: 0px;
      width: 6px;
    }

    &::-webkit-scrollbar-thumb {
      border-radius: $border-radius-large;
      background-color: $color-grey-pale;
    }
  }

  .base-dialog__actions {
    padding: 32px;
    background: transparent;
  }

  .close-icon__container {
    display: none;
  }
}
</style>
